var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoViolet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.2745475769043 43.65999794006348",
    preserveAspectRatio: "xMidYMid meet",
    className: "css-1cs2450",
    id: "fehgdfhd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs2702"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient2707"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2708",
    stopColor: "#7f00ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2709",
    stopColor: "#e100ff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient2710"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2711",
    stopColor: "#7f00ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2712",
    stopColor: "#e100ff",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG2703",
    featurekey: "Wg4LIr-0",
    transform: "matrix(2.297296823595032,0,0,2.297296823595032,7.286732385767882,-2.4864764499197367)",
    fill: "url(#SvgjsLinearGradient2707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.88 5 q0.28 0 0.49 0.21 t0.21 0.49 l0 13.4 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.76 0 q-0.36 0 -0.58 -0.28 l-9.78 -13.4 q-0.12 -0.16 -0.14 -0.36 t0.07 -0.38 t0.26 -0.28 t0.37 -0.1 l1.76 0 q0.16 0 0.32 0.07 t0.24 0.21 l7.02 9.54 l0 -9.12 q0 -0.28 0.2 -0.49 t0.5 -0.21 l1.52 0 z M3.84 14.7 q0.28 0 0.49 0.2 t0.21 0.5 l0 3.7 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.52 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -3.7 q0 -0.3 0.21 -0.5 t0.49 -0.2 l1.52 0 z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG2704",
    featurekey: "qafomr-0",
    transform: "matrix(2.25,0,0,2.25,46.35499972105026,-1.249998927116394)",
    fill: "url(#SvgjsLinearGradient2710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84 10.94 q0.3 0 0.5 0.21 t0.2 0.51 l0 7.48 q0 0.28 -0.2 0.49 t-0.5 0.21 l-1.52 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -7.48 q0 -0.3 0.21 -0.51 t0.49 -0.21 l1.52 0 z M3.84 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 3.7 q0 0.3 -0.2 0.51 t-0.5 0.21 l-1.52 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.51 l0 -3.7 q0 -0.28 0.21 -0.49 t0.49 -0.21 l1.52 0 z M17.28 11.12 q0.3 0 0.51 0.21 t0.21 0.51 l0 1.48 q0 0.28 -0.21 0.49 t-0.51 0.21 l-6.58 0 l0 5.12 q0 0.28 -0.2 0.49 t-0.5 0.21 l-1.52 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -7.3 q0 -0.3 0.21 -0.51 t0.49 -0.21 l8.8 0 z M18.18 5 q0.28 0 0.49 0.21 t0.21 0.49 l0 1.46 q0 0.3 -0.21 0.51 t-0.49 0.21 l-9.7 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.51 l0 -1.46 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.7 0 z M22.4 5 q0.3 0 0.51 0.21 t0.21 0.51 l0 1.46 q0 0.3 -0.21 0.51 t-0.51 0.21 l-2.06 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.51 l0 -1.46 q0 -0.3 0.21 -0.51 t0.49 -0.21 l2.06 0 z M31.34 5 q0.28 0 0.49 0.21 t0.21 0.51 l0 1.46 q0 0.3 -0.21 0.51 t-0.49 0.21 l-4.02 0 l0 11.36 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.54 0 q-0.3 0 -0.51 -0.21 t-0.21 -0.49 l0 -13.54 q0 -0.3 0.21 -0.51 t0.51 -0.21 l6.26 0 z M46.54 5.380000000000001 q0.1 0.18 0.09 0.38 t-0.13 0.36 l-5.54 8 l0 5.14 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.54 0 q-0.3 0 -0.51 -0.21 t-0.21 -0.49 l0 -5.86 q0 -0.2 0.14 -0.4 l5.34 -7.7 q0.1 -0.14 0.25 -0.22 t0.33 -0.08 l1.86 0 q0.2 0 0.37 0.1 t0.25 0.28 z M38.12 9.78 q-0.08 0.18 -0.25 0.28 t-0.37 0.1 l-1.86 0 q-0.36 0 -0.6 -0.3 l-2.6 -3.74 q-0.1 -0.16 -0.11 -0.36 t0.07 -0.38 t0.25 -0.28 t0.37 -0.1 l1.88 0 q0.34 0 0.58 0.3 l2.6 3.74 q0.1 0.16 0.11 0.36 t-0.07 0.38 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoViolet);
export default __webpack_public_path__ + "static/media/LogoViolet.eab19430b49bc1801bcef0467ec07976.svg";
export { ForwardRef as ReactComponent };